module.exports = __webpack_public_path__ + "static/B02-6a38972a4f5be1a1dcc2ce02d4b90933.jpg";